





import Vue from 'vue'
import Login from '../Login.vue'
import store from '../../store'
export default Vue.extend({
  name: 'LoginModal',
  components: {
    Login
  },
  computed: {
    askLogin () {
      return store.state.askLogin
    }
  },
  watch: {
    askLogin (payload) {
      if (!payload) {
        this.$modal.hide('login')
      }
    }
  }
})
